<template>
    <div class="campaign-progress">
        <v-row class="progress-header mb-2">
            <v-col cols="6" class="d-flex align-center pb-0">
                <h2 class="raised-amount">${{ totalRaisedFormatted }} raised</h2>
            </v-col>
            <v-col cols="6" class="d-flex justify-end align-center pb-0">
                <p class="goal-amount"><span>Goal:</span> ${{ goal }}</p>
            </v-col>
        </v-row>

        <v-card class="progress-card" elevation="0" outlined>
            <v-progress-linear
                :value="progressPercent"
                rounded
                height="40"
                class="progress-bar"
                background-color="#f4f5f6"
                color="#40B771"
            >
                <strong v-if="totalRaised > 0" class="white--text">{{ Math.ceil(progressPercent) }}%</strong>
            </v-progress-linear>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'CampaignProgress',
    props: {
        donations: {
            type: Array,
            default: () => []
        },
        goal: {
            type: Number,
            required: true
        }
    },
    computed: {
        totalRaised() {
            if (!this.donations?.length) return 0
            return this.donations.reduce((sum, d) => sum + Number(d.amount), 0)
        },
        totalRaisedFormatted() {
            return (this.totalRaised / 100).toFixed(2)
        },
        progressPercent() {
            if (!this.goal) return 0
            const raised = this.totalRaised / 100
            return Math.min((raised / this.goal) * 100, 100)
        }
    }
}
</script>

<style scoped>
.raised-amount {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.goal-amount {
    font-size: 16px;
    color: #666;
    margin: 0;
}

.goal-amount span {
    font-weight: 600;
}

.progress-card {
    border-radius: 25px !important;
    overflow: hidden;
}

.progress-bar {
    border-radius: 25px;
}

@media (max-width: 600px) {
    .raised-amount {
        font-size: 20px;
    }
}
</style>
